<template>
  <div class="main-collection container critical-component-clear">
    <div v-if="activeCampaign && discountCode && !hideHint" class="grid">
      <hint-message
        class="main-collection__hint-message col xs-span l6"
        center-icon
        :content="activeCampaignMessage"
      >
        <template #icon>
          <icon-check-fill />
        </template>
      </hint-message>
    </div>

    <product-grid
      :collection-product-count="productCount"
      :default-sort-by="$variable('collection.sortBy')"
      :disturber="disturber"
      :handle="metaobjectHandle || $variable('page.handle')"
      :products-per-page="$variable('settings.pagination.products')"
      :template="metaobjectHandle ? 'custom' : 'collection'"
      :hide-soldout="hideSoldout"
      :hide-banner="hideBanner"
      :infinite-scroll="infiniteScroll"
    />
  </div>
</template>

<script>
/**
 * Vue: Main collection (main-collection)
 * -----------------------------------------------------------------------------
 * Main collection section used on the PLP.
 */
import { mapState } from 'pinia';
import useDiscountCampaignsStore from '~stores/discount-campaigns';

import HintMessage from '~async/hint-message/hint-message';
import ProductGrid from '~async/product-grid/product-grid';

import IconCheckFill from '~icons/general/check-fill.svg';

export default {
  name: 'MainCollection',

  components: {
    HintMessage,
    IconCheckFill,
    ProductGrid,
  },

  provide() {
    return {
      variantsShowCount: this.variantsShowCount,
      variantsShowQatcOverlay: this.variantsShowQatcOverlay,
    };
  },

  props: {
    disturber: {
      type: Array,
      default: () => [],
    },
    productCount: {
      type: Number,
      default: 0,
    },
    metaobjectHandle: {
      type: String,
      default: '',
    },
    hideSoldout: {
      type: Boolean,
      default: false,
    },
    infiniteScroll: {
      type: Boolean,
      default: true,
    },
    hideBanner: {
      type: Boolean,
      default: false,
    },
    hideHint: {
      type: Boolean,
      default: false,
    },
    variantsShowCount: {
      type: Boolean,
      default: true,
    },
    variantsShowQatcOverlay: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    /**
     * Map Pinia state.
     */
    ...mapState(useDiscountCampaignsStore, {
      activeCampaign: 'active',
      discountCode: 'code',
    }),

    /**
     * Compute active campaign message.
     * @returns {String}
     */
    activeCampaignMessage() {
      if (!this.activeCampaign || !this.discountCode) {
        return '';
      }

      const discount = `${this.activeCampaign?.maxDiscount}%`;

      const string = this.$string(
        'discount_campaigns.collection_message_html',
        {
          // Decoding '50%' throws an error
          decode: false,
          replace: {
            code: this.discountCode,
            discount,
          },
        },
      );

      return string?.replace(
        '<strong',
        '<strong class="text-mobile-paragraph-m-bold text-desktop-paragraph-s-bold"',
      );
    },
  },
};
</script>

<style lang="scss">
@import './main-collection';
</style>
